import { QFilterGeneric } from './QFilterGeneric'

export class QFilterBP extends QFilterGeneric {
  name = "business_process";
  class_name = "QFilterBP";
  api_name = 'business_process';
  
}
